module.exports = __webpack_public_path__ + "img/ko.91fd0519.png";